var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "loan-purpose-picker",
          style: {
            borderBottomWidth:
              _setup.selectedPurpose && _setup.selectedPurpose.warn ? 0 : "1px",
          },
          attrs: {
            role: "radiogroup",
            "aria-labelledby": _setup.ariaLabelledby,
          },
        },
        _vm._l(_setup.__purposes, function (purposes, i) {
          return _c(
            "div",
            { key: i },
            _vm._l(purposes, function (purpose, j) {
              return _c(
                "div",
                {
                  key: j,
                  ref: "loanPurposesRef",
                  refInFor: true,
                  staticClass: "loan-purpose",
                  class: { selected: purpose.description === _setup.value },
                  attrs: {
                    tabindex: "0",
                    role: "radio",
                    "aria-checked": purpose.description === _setup.value,
                  },
                  on: {
                    click: function ($event) {
                      _setup.proxyValue = purpose.description
                    },
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        )
                          return null
                        return _setup.onProbableClick.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _setup.onProbableClick.apply(null, arguments)
                      },
                    ],
                  },
                },
                [
                  purpose.description === _setup.value
                    ? _c(
                        "div",
                        [_c(_setup.CheckCircleIcon, { attrs: { size: 18 } })],
                        1
                      )
                    : _c(
                        "div",
                        [_c(_setup.CircleOutlineIcon, { attrs: { size: 18 } })],
                        1
                      ),
                  _vm._v(" "),
                  _c("span", {
                    domProps: { textContent: _vm._s(purpose.description) },
                  }),
                ]
              )
            }),
            0
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        _setup.SmoothReflow,
        { attrs: { options: { property: ["height"] } } },
        [
          _setup.selectedPurpose && _setup.selectedPurpose.warn
            ? _c("div", { staticClass: "lp-tip" }, [
                _c(
                  "div",
                  {
                    staticClass: "lp-tip__icon",
                    attrs: { "aria-hidden": "true" },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "currentColor",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("p", {
                  staticClass: "lp-tip__text",
                  domProps: {
                    textContent: _vm._s(_setup.selectedPurpose.warn),
                  },
                }),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }